<template>
  <el-card body-style="padding:0px 20px" shadow="never">
    <h3 class="common-title mb10">面试辅导<el-button class="ml10" type="text" @click="toEdit">编辑</el-button></h3>
    <div class="card-content">
      <!-- <div class="project-detail-content">
        <div :class="[hasNotValueFields.includes('面试安排') ? 'warning-text' : '', 'project-detail-content-title mb10']">公司面试流程（来自公司信息）：</div>
        <pre>{{ project.面试安排 || '暂无面试安排' }}</pre>
      </div> -->
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('面试流程') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          项目面试流程（1%<el-tooltip
            class="item"
            style="display:inline;color:#409EFF"
            effect="dark"
            content="业绩贡献率"
            placement="top"
            ><i class="el-icon-question"></i></el-tooltip
          >）：
        </div>
        <pre>{{ project.面试流程 || '暂无面试流程' }}</pre>
      </div>
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('关键面试人') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          关键面试决策人：
        </div>
        <div class="flex flex-column">
          <!-- <div v-for="(item, index) in interviewer" :key="`interviewer${index}`" class="hr-card mr10 mb5">
            <div class="half-box">
              <span class="name text-btn" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
              <div class="job-box">
                <p>{{ item.目前职位 }}</p>
                <p>{{ item.职级 }}</p>
              </div>
            </div>
            <div class="half-box">
              <p class="tel">{{ item.手机 }}</p>
              <p class="gray">{{ item.座机 }}</p>
              <p class="gray">{{ item.邮箱 }}</p>
            </div>
          </div> -->
          <div v-for="(item, index) in interviewer" :key="`interviewerHr${index}`" class="new-hr-card mb5">
            <div class="new-hr-card-row">
              <span class="label text-btn" style="font-size:18px;" @click="showRadish({ id: item._id })">{{
                item.姓名
              }}</span>
              <div class="content">
                <span class="mr10">{{ item.公司 }}</span> <span class="mr10">{{ item.部门 }}</span>
                <span class="mr10">{{ item.目前职位 }}</span>
              </div>
            </div>
            <div class="new-hr-card-row">
              <span class="label">人选简介：</span>
              <div class="content">
                <pre>{{ item.简介 }}</pre>
              </div>
            </div>
            <div class="new-hr-card-row">
              <span class="label">面试风格：</span>
              <div class="content">
                <pre>{{ item.面试风格 }}</pre>
              </div>
            </div>
            <div class="new-hr-card-row" style="justify-content: flex-end;">
              <el-button size="mini" plain @click="copy">复制面试辅导发给人选</el-button>
            </div>
          </div>

          <p class="field-alert">
            提示：若为非公开信息，且比较私密，并且不是那么光鲜，不要文字发出，将相关内容删除，编辑好可以公开的版本再发给人选。不然会导致直线觉得自己的隐私被暴露，对人选和猎头产生不好的印象。
          </p>
        </div>
      </div>
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('面试辅导') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          项目面试辅导（1%<el-tooltip
            class="item"
            style="display:inline;color:#409EFF"
            effect="dark"
            content="业绩贡献率"
            placement="top"
            ><i class="el-icon-question"></i></el-tooltip
          >）：
        </div>
        <pre>{{ project.面试辅导 || '暂无面试辅导' }}</pre>
      </div>
      <div class="project-detail-content">
        <div class="project-detail-content-title mb10">对接hr：</div>
        <div v-if="projectHRs && projectHRs.length > 0" class="flex flex-wrap mb10" style="padding: 0 10px 0 30px;">
          <!-- <div v-for="(item, index) in projectHRs" :key="`interviewerHr${index}`" class="new-hr-card mb5">
            <div class="new-hr-card-row">
              <span class="label text-btn" style="font-size:18px;" @click="showRadish({ id: item._id })">{{item.姓名}}</span>
              <div class="content">
                <span class="mr10">{{item.公司}}</span>
                <span class="mr10">{{item.部门}}</span>
                <span class="mr10">{{item.目前职位}}</span>
              </div>
            </div>
            <div class="new-hr-card-row">
              <span class="label">人选简介：</span>
              <div class="content">
                <pre>{{item.简介}}</pre>
              </div>
            </div>
            <div class="new-hr-card-row">
              <span class="label">面试风格：</span>
              <div class="content">
                <pre>{{item.面试风格}}</pre>
              </div>
            </div>
            <div class="new-hr-card-row" style="justify-content: flex-end;">
              <el-button size="mini" plain @click="copy">复制面试辅导发给人选</el-button>
            </div>
          </div> -->
          <div v-for="(item, index) in projectHRs" :key="`interviewerHr${index}`" class="hr-card mr10 mb5">
            <div class="half-box">
              <span class="name text-btn" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
              <div class="job-box">
                <p>{{ item.目前职位 }}</p>
                <p>{{ item.职级 }}</p>
              </div>
            </div>
            <div class="half-box">
              <p class="tel">{{ item.手机 }}</p>
              <p class="gray">{{ item.座机 }}</p>
              <p class="gray">{{ item.邮箱 }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="project-detail-content">
        <div class="project-detail-content-title mb10">直线领导：</div>
        <div v-if="projectLeaders && projectLeaders.length > 0" class="flex flex-wrap mb10" style="padding: 0 10px 0 30px;">
          <div v-for="(item, index) in projectLeaders" :key="`projectLeaders${index}`" class="hr-card mr10 mb5">
            <div class="half-box">
              <span class="name text-btn" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
              <div class="job-box">
                <p>{{ item.目前职位 }}</p>
                <p>{{ item.职级 }}</p>
              </div>
            </div>
            <div class="half-box">
              <p class="tel">{{ item.手机 }}</p>
              <p class="gray">{{ item.座机 }}</p>
              <p class="gray">{{ item.邮箱 }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="project-detail-content">
        <div
          :class="[hasNotValueFields.includes('面试地址') ? 'warning-text' : '', 'project-detail-content-title mb10']"
        >
          面试地址（来自公司信息）：
        </div>
        <div v-if="project.面试地址word">{{project.面试地址word}}</div>
        <!-- <table v-if="project.面试地址 && project.面试地址.length > 0" class="hr mb10 ft14" style="width:100%">
          <thead>
            <td>地址</td>
            <td>备注</td>
          </thead>
          <tbody>
            <tr v-for="item in project.面试地址" :key="item._id">
              <td>{{ item['地址'] }}</td>
              <td>{{ item['备注'] }}</td>
            </tr>
          </tbody>
        </table> -->
      </div>
    </div>

    <el-dialog
      :visible.sync="isEditing"
      custom-class="custom-dialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div slot="title" class="title">
        <div class="title-name">面试辅导</div>
        <div class="side-title"></div>
        <!-- <div class="handle-btn">
          <el-button size="mini" type="text" @click="openHistory('项目基本信息')">操作记录</el-button>
        </div> -->
      </div>
      <div class="card-content">
        <!-- <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('面试安排') ? 'warning-text' : '', 'field-label']">公司面试流程（来自公司信息） </span>
          <el-input
            v-model="projectInEdit.面试安排"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该公司面试安排"
          ></el-input>
        </div> -->
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('面试流程') ? 'warning-text' : '', 'field-label']"
            >项目面试流程（1%<el-tooltip
              class="item"
              style="display:inline;color:#409EFF"
              effect="dark"
              content="业绩贡献率"
              placement="top"
              ><i class="el-icon-question"></i></el-tooltip
            >）
          </span>
          <el-input
            v-model="projectInEdit.面试流程"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该职位面试流程"
          ></el-input>
        </div>
        <!-- 关键面试人 -->
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('关键面试决策人') ? 'warning-text' : '', 'field-label']"
            >关键面试决策人（1%<el-tooltip
              class="item"
              style="display:inline;color:#409EFF"
              effect="dark"
              content="业绩贡献率"
              placement="top"
              ><i class="el-icon-question"></i></el-tooltip
            >）
            <el-popover
              v-if="company._id"
              v-model="companyInterviewerVisible"
              placement="right"
              width="800"
              trigger="click"
            >
              <div class="propject_detail_info_table col-1" style="max-height:70vh;font-size:14px;padding:10px">
                <p style="text-align:center;margin-bottom:20px" class="flex-row">
                  <el-input v-model="temporaryInterviewerKeyword" size="mini" placeholder="输入姓名进行搜索"></el-input>
                  <el-button size="mini" type="primary" @click="getTemporaryInterviewers(temporaryInterviewerKeyword)"
                    >搜索</el-button
                  >
                </p>
                <p class="mb10" style="color:#409EFF">点击选择一位关键面试决策人(可多选)</p>
                <div v-if="interviewerLoading" class="loading-mask"><i class="el-icon-loading"></i></div>
                <div v-else>
                  <div class="flex-row project_table_thead item-center">
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">姓名</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">公司</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">部门</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">目前职位</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职级</span>
                    <span class="propject_detail_info_table_cell col-2 propject_detail_info_label">职能模块</span>
                  </div>
                  <div
                    v-for="(value, i) in temporaryInterviewer"
                    :key="`companyHr${i}`"
                    :class="`flex-row item-center propject_detail_info_table_row_link ${i % 2 === 0 ? 'bg-gray' : ''}`"
                    @click="chooseInterviewer(value)"
                  >
                    <span class="propject_detail_info_table_cell col-2">{{ value['姓名'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['公司'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['部门'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['目前职位'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">{{ value['职级'] }}</span>
                    <span class="propject_detail_info_table_cell col-2">
                      <el-tag v-for="item in value['职能模块']" :key="item" size="mini" type="primary">{{
                        item
                      }}</el-tag>
                    </span>
                  </div>
                </div>
              </div>
              <i slot="reference" class="el-icon-circle-plus text-btn mb10" style="font-size:16px;" />
            </el-popover>
          </span>
          <div class="flex flex-wrap">
            <div v-for="(item, index) in tempInterviewer" :key="`interviewer${index}`" class="hr-card mr10 mb5">
              <span class="close" @click="removeInterviewer(item)">X</span>
              <div class="half-box">
                <span class="name text-btn" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
                <div class="job-box">
                  <p>{{ item.目前职位 }}</p>
                  <p>{{ item.职级 }}</p>
                </div>
              </div>
              <div class="half-box">
                <p class="tel">{{ item.手机 }}</p>
                <p class="gray">{{ item.座机 }}</p>
                <p class="gray">{{ item.邮箱 }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- 关键面试人 end -->
        <div class="card-content-textarea-item">
          <span :class="[hasNotValueFields.includes('面试辅导') ? 'warning-text' : '', 'field-label']"
            >项目面试辅导（1%<el-tooltip
              class="item"
              style="display:inline;color:#409EFF"
              effect="dark"
              content="业绩贡献率"
              placement="top"
              ><i class="el-icon-question"></i></el-tooltip
            >）
          </span>
          <el-input
            v-model="projectInEdit.面试辅导"
            class="mb15"
            type="textarea"
            :rows="2"
            placeholder="请输入该职位面试辅导"
          ></el-input>
        </div>
        <!-- 对接hr -->
        <div class="card-content-item flex align-center space-between">
          <p>
            <span :class="[hasNotValueFields.includes('对接hr') ? 'warning-text' : '', 'field-label']">
              <span class="require-field">*</span>对接hr
            </span>
            <span class="field-alert">下列为该客户公司招聘HR,请选择此项目对接HR(没有可新建,请先选择客户公司）</span>
          </p>
          <span class="text-btn" @click="companyHrVisible = true">新增</span>
        </div>
        <div v-if="projectInEdit.对接hr && projectInEdit.对接hr.length > 0" class="flex flex-wrap mb10">
          <div v-for="(item, index) in projectInEdit.对接hr" :key="`interviewer${index}`" class="hr-card mr10 mb5">
            <span class="close" @click="removeHr(item)">X</span>
            <div class="half-box">
              <span class="name text-btn" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
              <div class="job-box">
                <p>{{ item.目前职位 }}</p>
                <p>{{ item.职级 }}</p>
              </div>
            </div>
            <div class="half-box">
              <p class="tel">{{ item.手机 }}</p>
              <p class="gray">{{ item.座机 }}</p>
              <p class="gray">{{ item.邮箱 }}</p>
            </div>
          </div>
        </div>
        <!-- 直线领导 -->
        <div class="card-content-item">
          <p class="field-label">直线领导</p>
          <div class="flex flex-wrap align-center">
            <div v-for="(item, index) in projectInEdit.直线领导" :key="`editleader${index}`" class="hr-card mr10 mb5">
              <span class="close" @click="removeLeader(item)">X</span>
              <div class="half-box">
                <span class="name text-btn" @click="showRadish({ id: item._id })">{{ item.姓名 }}</span>
                <div class="job-box">
                  <p>{{ item.目前职位 }}</p>
                  <p>{{ item.职级 }}</p>
                </div>
              </div>
              <div class="half-box">
                <p class="tel">{{ item.手机 }}</p>
                <p class="gray">{{ item.座机 }}</p>
                <p class="gray">{{ item.邮箱 }}</p>
              </div>
            </div>
            <el-button size="mini" type="primary" plain @click="addLeader">+新增一位直线领导</el-button>
          </div>
        </div>
        <div v-if="company._id && companyHrVisible" class="project-hr-box mb10">
          <div class="project-hr-box-header mb10">
            <span class="field-alert">点击<span class="text-btn">选择</span>即可添加（可多选）</span>
            <span class="text-btn" @click="addHr">+新增一位hr</span>
          </div>
          <table class="hr" style="margin-bottom:10px;width: 100%;">
            <thead>
              <td>操作</td>
              <td>姓名</td>
              <td>目前职位</td>
              <td>职级</td>
              <td>手机</td>
              <td>座机</td>
              <td>邮箱</td>
            </thead>
            <tbody>
              <tr v-for="item in filterCompanyHr(company.对接hr)" :key="item._id">
                <td>
                  <span v-if="!hasChooseHr.find(v => v._id === item._id)" class="text-btn" @click="chooseHr(item)"
                    >选择</span
                  >
                  <span v-else class="text-btn warning-text" @click="cancelChooseHr(item)">取消</span>
                </td>
                <td>{{ item['姓名'] }}</td>
                <td>{{ item['目前职位'] }}</td>
                <td>{{ item['职级'] }}</td>
                <td>{{ item['手机'] }}</td>
                <td>{{ item['座机'] }}</td>
                <td>{{ item['邮箱'] }}</td>
              </tr>
            </tbody>
          </table>
          <div class="flex justify-center">
            <el-button style="margin-right:30px" type="primary" size="mini" plain @click="addProjectHr">确定</el-button>
            <span class="text-btn" @click="addHr">+新增一位hr</span>
          </div>
        </div>
        <!-- 对接hr end -->

        <div>
          <div class="card-content-item flex align-center space-between">
            <p>
              <span :class="[hasNotValueFields.includes('面试地址') ? 'warning-text' : '', 'field-label']">
                面试地址（来自公司信息）
              </span>
            </p>
            <!-- <span class="text-btn" @click="interviewAddressVisible = true">新增</span> -->
          </div>
          <div>
            <el-input
              v-model="projectInEdit.面试地址word"
              class="mb15"
              placeholder="请输入面试地址"
            ></el-input>
          </div>
          <!-- <table v-if="projectInEdit.面试地址 && projectInEdit.面试地址.length > 0" class="hr mb10" style="width:100%">
            <thead>
              <td>地址</td>
              <td>备注</td>
              <td style="min-width:100px;">操作</td>
            </thead>
            <tbody>
              <tr v-for="item in projectInEdit.面试地址" :key="item._id">
                <td>{{ item['地址'] }}</td>
                <td>{{ item['备注'] }}</td>
                <td @click="removeAddress(item)"><span class="text-btn danger">删除</span></td>
              </tr>
            </tbody>
          </table>
          <div v-if="company._id && company.面试地址 && interviewAddressVisible" class="project-hr-box mb10">
            <div class="project-hr-box-header mb10">
              <span class="field-alert">点击<span class="text-btn">选择</span>即可添加（可多选）</span>
              <span class="text-btn" @click="toAddAddress">+添加面试地址</span>
            </div>
            <table class="hr mb10" style="width:100%">
              <thead>
                <td style="min-width:100px;">操作</td>
                <td>地址</td>
                <td>备注</td>
              </thead>
              <tbody>
                <tr v-for="item in filterInterviewAddress(company.面试地址)" :key="item._id">
                  <td>
                    <span
                      v-if="!hasChooseAddress.find(v => v._id === item._id)"
                      class="text-btn"
                      @click="chooseAddress(item)"
                      >选择</span
                    >
                    <span v-else class="text-btn warning-text" @click="cancelChooseAddress(item)">取消</span>
                  </td>
                  <td>{{ item['地址'] }}</td>
                  <td>{{ item['备注'] }}</td>
                </tr>
              </tbody>
            </table>
            <div class="flex justify-center">
              <el-button style="margin-right:30px" type="primary" size="mini" plain @click="addProjectAddress"
                >确定</el-button
              >
              <span class="text-btn" @click="toAddAddress">+添加面试地址</span>
            </div>
          </div> -->
        </div>
      </div>
      <div slot="footer">
        <el-row type="flex" align="center" justify="center">
          <el-button size="small" type="info" style="margin-right:20px" @click="cancelEdit">取消</el-button>
          <el-button size="small" type="primary" class="custom-primary-plain" @click="confirmEdit">保存</el-button>
        </el-row>
      </div>
      <SearchRadishDialog
        ref="SearchRadishDialog"
        :could-insert="true"
        choose-btn-text="选择"
        :default-company="project.客户公司"
        @choose="chooseLeader"
      >
      </SearchRadishDialog>
    </el-dialog>
    <!-- 新增面试地址 -->
    <addCompanyAddress ref="addCompanyAddress" @addAddress="addAddress"></addCompanyAddress>

    <AddRadish ref="AddRadish" @confirm="chooseRadish"></AddRadish>
  </el-card>
</template>
<script>
import addCompanyAddress from '../../../../company/src/dialog/addCompanyAddress'
import { defaultProject, defaultCompany } from '../../constant/defaultData'
import SearchRadishDialog from '../../../../company/src/component/serchRadishDialog'
import AddRadish from './AddRadish'
import mixin from './mixin'

export default {
  components: { addCompanyAddress, SearchRadishDialog, AddRadish },
  mixins: [mixin],
  props: {
    project: { type: Object, default: () => window._.cloneDeep(defaultProject) },
    company: { type: Object, default: () => window._.cloneDeep(defaultCompany) },
    hasNotValueFields: { type: Array, default: () => [] },
  },
  data() {
    return {
      // 关键面试人
      companyInterviewerVisible: false,
      temporaryInterviewerKeyword: '',
      interviewerLoading: false,
      temporaryInterviewer: [],
      interviewer: [],
      tempInterviewer: [],
      // 关键面试人 end
      // hr
      companyHrVisible: true,
      hasChooseHr: [],
      projectHrids: [],
      projectHRs: [],
      // hr end
      interviewAddressVisible: true,
      hasChooseAddress: [],
      componentType: '面试辅导',
      fields: [
        // '面试流程',
        '面试辅导',
        '关键面试人',
        '面试安排',
        '对接hr',
        '直线领导',
        '面试地址',
      ],
      projectLeaderIds:[],
      projectLeaders:[],
    }
  },
  watch: {
    companyInterviewerVisible(val) {
      if (val) {
        this.getTemporaryInterviewers()
      }
    },
    'project._id'(newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        this.getProjectHr()
        this.getProjectLeader()
      }
    },
    async projectHrids(newValue, oldValue) {
      this.projectHRs = await this.getCompanyHrsByIds(newValue || [])
    },
    async projectLeaderIds(newValue, oldValue) {
      this.projectLeaders = await this.getLeadersByIds(newValue || [])
    },
  },
  mounted() {
    this.$watch(
      function() {
        // 第一个函数就是处理你要监听的属性，只要将其return出去就行
        return this.project.职能模块
      },
      function(newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.getInterviewer()
        }
      },
    )
  },
  methods: {
    removeAddress(item) {
      this.projectInEdit.面试地址 = this.projectInEdit.面试地址.filter(v => v._id !== item._id)
    },
    chooseAddress(item) {
      this.hasChooseAddress.push(item)
    },
    cancelChooseAddress(item) {
      this.hasChooseAddress = this.hasChooseAddress.filter(v => v !== item)
    },
    addProjectAddress() {
      const addresses = this.projectInEdit.面试地址 || []
      addresses.push(...this.hasChooseAddress)
      this.$set(this.projectInEdit, '面试地址', addresses)
      this.hasChooseAddress = []
      this.interviewAddressVisible = false
    },
    filterInterviewAddress(addresses = []) {
      const address = this.projectInEdit.面试地址 || []
      const ids = address.map(v => v._id)
      return addresses.filter(v => !ids.includes(v._id))
    },
    toAddAddress() {
      this.$refs.addCompanyAddress.open()
    },
    async addAddress(obj) {
      obj.cid = this.company._id
      try {
        const res = await app.service('company').addCompanyAddress(obj)
        if (res.status === 'success') {
          this.$set(this.company, '面试地址', res.data)
          const item = res.data.find(v => v.地址 === obj.地址)
          this.chooseAddress(item)
          this.$message.success(`操作成功`)
        }
      } catch (e) {
        this.$message.error(e.message)
      }
    },

    toEdit() {
      this.projectInEdit = {}
      this.fields.forEach(key => {
        if (key === '对接hr') {
          const value = window._.cloneDeep(this.projectHRs || [])
          this.$set(this.projectInEdit, key, value)
        }else if(key === '直线领导'){
          const value = window._.cloneDeep(this.projectLeaders || [])
          this.$set(this.projectInEdit, key, value)
        } else {
          const value =
            this.project[key] ||
            (typeof defaultProject[key] === 'object' ? window._.cloneDeep(defaultProject[key]) : '')
          if (value && typeof value === 'object') {
            const newVal = JSON.parse(JSON.stringify(value))
            this.$set(this.projectInEdit, key, newVal)
          } else {
            this.$set(this.projectInEdit, key, value)
          }
        }
      })
      this.tempInterviewer = window._.cloneDeep(this.interviewer || [])
      // this.company = window._.cloneDeep(this.company)
      this.isEditing = true
    },
    async confirmEdit() {
      if (!this.isEditing) return
      if (Object.keys(this.projectInEdit).length === 0) return
      try {
        const param = window._.cloneDeep(this.projectInEdit)
        param.对接hr = (param.对接hr || []).map(v => v._id).filter(v => v)
        const leaderSaveFields = ['_id','姓名','目前职位','职级','手机','座机','邮箱']
        param.直线领导 = (param.直线领导 || []).filter(v => v).map(v=>{
          const obj = {}
          leaderSaveFields.forEach(a=>obj[a] = v[a])
          return obj
        })
        await app.service('project').modify({
          id: this.project._id,
          param: param,
        })
        Object.assign(this.project, param)
        this.getProjectHr()
        this.getProjectLeader()
        this.getInterviewer()
        this.$emit('confirmEdit', { type: this.componentType, data: this.projectInEdit })
        this.$message.success(`修改成功`)
      } catch (e) {
        this.$message.error(`修改失败:${e.msg}`)
      }
      this.isEditing = false
    },
    // 关键面试人
    showRadish(opts) {
      window.open(`${window.frontend}/#/radish-detail-blank/${opts.id}`, '_blank')
    },
    async getInterviewer() {
      const ids = this.project['关键面试人']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.interviewer = res.data
      } else this.interviewer = []
    },
    async getTempInterviewer() {
      const ids = this.projectInEdit['关键面试人']
      if (ids && ids.length !== 0) {
        const res = await app.service('radish').findByIds({ ids })
        this.tempInterviewer = res.data
      } else this.tempInterviewer = []
    },
    chooseInterviewer(radish) {
      if (!this.projectInEdit['关键面试人']) this.$set(this.projectInEdit, '关键面试人', [])
      if (!this.projectInEdit['关键面试人'].includes(radish._id)) this.projectInEdit['关键面试人'].push(radish._id)
      this.$message({ type: 'success', message: `添加成功` })
      this.getTempInterviewer()
      this.companyInterviewerVisible = false
    },
    removeInterviewer(radish) {
      const index = this.tempInterviewer.findIndex(_hrid => _hrid._id === radish._id)
      const idIndex = this.projectInEdit['关键面试人'].findIndex(_hrid => _hrid === radish._id)
      if (index === -1) return
      this.projectInEdit['关键面试人'].splice(idIndex, 1)
      this.tempInterviewer.splice(index, 1)
    },
    async getTemporaryInterviewers(name) {
      this.interviewerLoading = true
      if (!name) {
        if (!this.project['客户公司']) return
        const res = await app.service('misc').searchEs({
          type: '人选',
          keywords: this.project['客户公司'],
          fields: ['公司^5'],
          and: true,
        })
        if (res.status === 'success') {
          this.temporaryInterviewer = res.data
          this.temporaryInterviewerKeyword = ''
          this.interviewerLoading = false
        } else this.$message.error(res.msg)
      } else {
        const res = await app.service('misc').searchEs({
          type: '人选',
          keywords: name,
          fields: ['姓名^5', '拼音', '公司^5', '职能模块', '手机'],
          and: true,
        })
        if (res.status === 'success') {
          this.temporaryInterviewer = res.data
          this.temporaryInterviewerKeyword = ''
          this.interviewerLoading = false
        } else this.$message.error(res.msg)
      }
    },

    // hr
    async getCompanyHrsByIds(hrids) {
      if (!hrids || hrids.length === 0) return []
      const hrs = []
      const res1 = await app.service('company').getCompanyHrsByIds(hrids)
      if (res1.status == 'success') {
        res1.data.forEach(h=>{
          hrs.push(h)
        })
      }
      const res2 = await app.service('radish').simpleList({
        query: {_id: {$in: hrids}},
        fields: { 姓名: 1, 手机: 1, 座机:1, 邮箱:1, 公司: 1, 部门: 1, 目前职位:1, 职能模块: 1, 职级: 1 },
      })
      if (res2.status == 'success') {
        res2.data.forEach(h=>{
          h.cid = h._id
          hrs.push(h)
        })
      }
      return hrs
    },
    async getLeadersByIds(ids) {
      if (!ids || ids.length === 0) return []
      const res = await app.service('radish').simpleList({
        query: { _id: { $in: ids } },
        fields: { 姓名: 1, 目前职位: 1, 职级: 1, 手机: 1, 座机: 1, 邮箱: 1 },
      })
      return res.status === 'success' ? res.data : []
    },
    getProjectHr(val) {
      this.projectHrids = val || this.project['对接hr'] || []
    },
    getProjectLeader(val) {
      this.projectLeaderIds = (val || this.project['直线领导'] || []).map(v=>v._id)
    },
    removeLeader(item) {
      this.projectInEdit.直线领导 = this.projectInEdit.直线领导.filter(v => v._id !== item._id)
    },
    addLeader() {
      this.$refs.SearchRadishDialog.open()
    },
    chooseLeader(radish) {
      if (!this.projectInEdit.直线领导) this.$set(this.projectInEdit, '直线领导', [])
      if(this.projectInEdit.直线领导.find(v=>v._id===radish._id)){
        this.$message.success('该人选已存在，请勿重复添加')
      }else{
        this.projectInEdit.直线领导.push(radish)
      }
    },
    addHr() {
      this.$refs.AddRadish.open({ 公司: this.project.客户公司 })
    },
    async chooseRadish(radish) {
      const hr = { rid: radish._id, cid: this.company._id }
      try {
        const res = await app.service('company').addCompanyHr(hr)
        if (res.status === 'success') {
          if (!this.company['对接hr']) this.company['对接hr'] = []
          delete radish._id
          Object.assign(res.data, radish)
          this.company['对接hr'].push(res.data)
          this.$message.success(`操作成功`)
        } else {
          this.$message.error(res.msg)
        }
      } catch (e) {
        this.$message.error(e)
      }
    },
    filterCompanyHr(hrs = []) {
      const projectHr = this.projectInEdit.对接hr || []
      const ids = projectHr.map(v => v._id)
      return hrs.filter(v => !ids.includes(v._id))
    },
    chooseHr(item) {
      this.hasChooseHr.push(item)
    },
    cancelChooseHr(item) {
      this.hasChooseHr = this.hasChooseHr.filter(v => v !== item)
    },
    addProjectHr() {
      const hr = this.projectInEdit.对接hr || []
      hr.push(...this.hasChooseHr)
      this.$set(this.projectInEdit, '对接hr', hr)
      this.hasChooseHr = []
      this.companyHrVisible = false
    },
    removeHr(item) {
      this.projectInEdit.对接hr = this.projectInEdit.对接hr.filter(v => v._id !== item._id)
    },
    copy() {},
  },
}
</script>
<style scoped>
.project-hr-box {
  border: 1px solid #eee;
  padding: 10px 20px;
  border-radius: 6px;
}
.project-hr-box-header {
  display: flex;
  justify-content: space-between;
}
</style>
<style scoped src="../../css/newProjectDetail.css"></style>
